"use strict";

export function initInScope ($scope) {
    let stickyBoxContainer = $scope.find(".detail-search-box ");
    let dtContainer = $scope.find(".content-search-box ");
    dtContainer.find(".form-control").each(function (e) {
        $(this).on("focus", function (e) {
            // console.log("FOCUSING, doing GRAY stuff");
            dtContainer.addClass("gray");
            let allFormGroups = dtContainer.find(".form-group-inline");
            allFormGroups.removeClass("white");
            allFormGroups.removeClass("nodashed-border");

            let closestFormGroup = $(this).closest(".form-group-inline");
            let thisIndex = allFormGroups.index(closestFormGroup[0]);

            allFormGroups.each(function (i, e) {
                if(i === thisIndex - 1) {
                    $(this).addClass("nodashed-border");
                }
            });
            let parent = $(this).parents(".form-group-inline:first")
            parent.addClass("white");
        });
    });
    // stickyBoxContainer.on("change", function (e) {
    //     window.loadNewPrice();
    // });


    let pullup = $(".portal-search-mobile-pullup");
    let fromToWrapper = pullup.find('.mobile-search-fromto-wrapper');
    // var fromToWrapper = pullup.find('.js-easypicker-container');
    let fixmeTop = fromToWrapper.offset().top;
    let slInput = pullup.find("#search-location .js-places-autocomplete.tt-input");
    let firstClick = true;
    let stickyMobile = $(".objekt-detail-sticky");
    // console.log("-----------------pullup");
    // console.log(pullup);
    function closePullup() {
        // console.log("_config.hashStack before pop", _config.hashStack);
        _config.hashStack.pop();
        // console.log("_config.hashStack", _config.hashStack);
        $("body").removeClass("modal-open");
        pullup.removeClass("open");

        let hasStack = _config.hashStack.length > 0;
        let newHash = hasStack ? '#' + _config.hashStack[_config.hashStack.length - 1] : '';
        // console.log(location);
        let newUrl = hasStack
            ? location.pathname + location.search + newHash
            : location.pathname + location.search;
        // console.log("updating hash");
        history.replaceState({hashStack: _config.hashStack}, '', newUrl);
    }
    stickyMobile.on("click", ".js-change-data", function (e) {
        e.preventDefault();
        if(pullup.hasClass("open")) {
            closePullup()
        } else {
            _config.hashStack.push('pullup');
            history.pushState({ hashStack: _config.hashStack }, '', '#pullup');
            $("body").addClass("modal-open");
            pullup.addClass("open");
            if($("#search-fromto").hasClass("show")) {
                $("#search-fromto").hide();
            }
        }
        return false;
    });
    $(".portal-search-mobile-pullup .portal-search-close").on("click", function (e) {
        closePullup();
        return false;
    });

    $scope.find(".portal-search__person-select").each(function () {
        let dummyEl = $(this).parent().find("input.dummy");
        let hiddenInputEl = $(this).parent().find("input.persons-hidden");
        let personsLocale = $(this).data("locale");
        let personLocale = $(this).data("locales");
        let personInput = $(this).find("input");
        let minPersons = $(this).data("min");
        let maxPersons = $(this).data("max");
        $(this).find(".add").on("click", function (e) {
            let value = personInput.val() ? parseInt(personInput.val()) : 0;
            if(value < maxPersons) {
                personInput.val(value + 1);
                hiddenInputEl.val(personInput.val());
                if(personInput.val() <= 1) {
                    dummyEl.val(personInput.val() + " " + personLocale);
                } else {
                    dummyEl.val(personInput.val() + " " + personsLocale);
                }
                personInput.trigger("change");
            }
            if(personInput.val() > 0) {
                $('.js-object-detail-persons-error').attr('hidden',true);
            }
        });
        $(this).find(".sub").on("click", function (e) {
            let value = personInput.val() ? parseInt(personInput.val()) : 0;
            if(value > minPersons) {
                personInput.val(value - 1);
                hiddenInputEl.val(personInput.val());
                if(personInput.val() <= 1) {
                    dummyEl.val(personInput.val() + " " + personLocale);
                } else {
                    dummyEl.val(personInput.val() + " " + personsLocale);
                }
                personInput.trigger("change");
            }
            if(personInput.val() > 0) {
                $('.js-object-detail-persons-error').attr('hidden',true);
            }
        });
    });
    $scope.on("click", ".price-type", function(e) {
        // console.log("clicking pricetype");
        e.preventDefault();
        let type = $(this).data("target");
        let totalEl = $scope.find(".price.total");
        let monthEl = $scope.find(".price.month");
        $scope.find(".price-type").removeClass("active");
        if(type === "month") {
            totalEl.hide();
            monthEl.show();
        } else {
            monthEl.hide();
            totalEl.show();
        }

        $(this).addClass("active");
        return false;
    });
}